import customWorld from '@highcharts/map-collection/custom/world.geo.json';
import { numberToHumanChart } from '../../utils/formatter';

export default (options = {}) => ({
  chart: {
    type: 'map',
    spacingBottom: 20,
    height: options.height,
  },
  title: {
    text: '',
  },
  xAxis: {
    crosshair: false,
  },
  legend: {
    enabled: options.legendEnabled,
    title: {
      text: options.legendTitle,
      fontWeight: 'normal',
      align: 'right',
      style: { fontSize: 18, fontWeigh: 'normal' },
    },
    align: 'right',
    verticalAlign: 'middle',
    floating: false,
    layout: 'vertical',
    valueDecimals: 0,
    symbolRadius: 2,
    symbolHeight: 24,
    itemMarginTop: 25,
    itemStyle: { fontSize: 12, lineHeight: 30 },
    x: 45,
    navigation: {
      enabled: false,
    },
    labelFormatter() {
      if (options.labelValue) return options.labelValue(this.to);
      let value;
      if (this.to < 1) {
        value = this.to;
      } else {
        value = numberToHumanChart(this.from || this.to, options.abbreviationSettings);
      }
      return `${value}`;
    },
  },
  mapNavigation: {
    enabled: false,
  },
  plotOptions: {
    map: {
      allAreas: false,
      joinBy: ['iso-a2', 'code'],
      allowPointSelect: false,
      dataLabels: {
        enabled: true,
        color: 'white',
        style: {
          fontWeight: 'bold',
        },
      },
      mapData: customWorld,
      tooltip: {
        headerFormat: '',
        pointFormat: '{point.name}: <b>{series.name}</b>',
      },
    },
  },
  tooltip: {
    padding: options.tooltipPadding || 8,
    formatter() {
      let rows;
      if (Array.isArray(this.points)) {
        rows = this.points.map((point) => options.tooltipFormatter(point));
      } else if (this && !Array.isArray(this)) {
        rows = options.tooltipFormatter(this);
      } else {
        return null;
      }
      return `
        <table class="table">${rows}</table>
      `;
    },
    positioner(boxWidth, boxHeight, point) {
      return {
        x: point.plotX - 65,
        y: point.plotY - 65,
      };
    },
  },
  series: [
    {
      name: 'countries',
      data: options.series,
    },
  ],
  colorAxis: {
    accessibility: {
      enabled: false,
    },
    align: 'left',
    dataClasses: options.dataClasses,
  },
});
